import { Skeleton, Stack, Typography } from "@mui/material";
import React from "react";
import SubContainer from "./SubContainer";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";

const MetricsCard = ({
  title,
  value,
  isLoading,
  comparedValue,
  percentageChange,
  doComparison,
}) => {
  return (
    <SubContainer
      spacing={2}
      sx={{
        flex: 1,
        height: "100%",
      }}
    >
      <Stack
        direction="row"
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          sx={{
            color: "#b6bed3",
            fontWeight: 500,
          }}
        >
          {title}
        </Typography>

        {doComparison && (
          <Stack direction={"row"} spacing={0.2}>
            {/* INCREASE/DECREASE ICONS */}
            {percentageChange > 0 ? (
              <TrendingUpIcon sx={{ color: "#fff" }} />
            ) : (
              <TrendingDownIcon sx={{ color: "#fff" }} />
            )}
            {/* PERCENTAGE CHANGE */}
            <Typography
              sx={{
                color: "#fff",
                fontWeight: 500,
              }}
            >
              {" "}
              {percentageChange + "%"}
            </Typography>
          </Stack>
        )}
      </Stack>

      {!isLoading ? (
        <Typography
          variant="h4"
          sx={{
            color: "#fff",
            fontWeight: 600,
            lineHeight: 1,
          }}
        >
          {value}
        </Typography>
      ) : (
        <Skeleton
          variant="rounded"
          width={"100%"}
          height={24}
          animation="wave"
          sx={{
            borderRadius: "8px",
            "&.MuiSkeleton-root": {
              backgroundColor: "#b6bed320",
            },
          }}
        />
      )}
      {doComparison && (
        <Typography
          sx={{
            color: "#b6bed3",
            fontWeight: 500,
          }}
        >
          Last year: {comparedValue}
        </Typography>
      )}
    </SubContainer>
  );
};

export default MetricsCard;
